module.exports = __webpack_public_path__ + "181f7750550aa2da0b07d282df9be8b3.mp3";